const ja = {
  here_today_coupon: "本日のクーポンはこちら",
  checkbox: {
    required: "必須",
    optional: "任意",
  },
  btn: {
    refresh: "再読み込み",
    next: "次へ",
    back: "前へ",
    ok: "はい",
    send_response: "回答を送信",
    register: "登録する",
    delete: "削除",
    answer: "回答する",
    use: "使う",
    dont_use: "使わない",
    close: "閉じる",
    send_test: "テスト送信",
  },
  calender: {
    incorrect_date_format: "不正な日付フォーマット",
    cannot_set_date_before_min_year: "最小値以前の日付は指定できません",
    today: "今日",
  },
  sample_coupon: "クーポン見本",
  use_coupon: "クーポンを使う",
  terms_and_conditions: "注意事項",
  only_half_width_numeric_characters: "※半角数字のみ",
  only_half_width_alphanumeric_characters: "※半角英数字のみ",
  enter_a_7_digit_number_without_hyphens: "ハイフンなし数字7桁で入力して下さい",
  seven_digit_number_no_hyphens: '数字7桁 (ハイフンなし)',
  this_coupon_has_already_been_used: "このクーポンは使用済みです",
  this_coupon_has_already_expired: "このクーポンの有効期限は既に過ぎています",
  can_only_be_used_by: "{{name}}でのみ利用できます",
  recommend_bookmarking_this_page: "※ブラウザにブックマークをお勧めします",
  can_be_used_from: "{{date}}からご利用いただけます",
  this_coupon_can_only_be_used_once: "このクーポンは一回に限り使用可能です。",
  cannot_be_used_again_after_displaying: "一度表示すると使えなくなります。",
  the_display_time_is_n_minutes_please_show_to_staff_within_n_minutes: 'また表示時間は{{minutes}}分間です。{{minutes}}分間の間にスタッフに見せてください。',
  cannot_be_used_yet: "まだご利用いただけません。",
  try_again_after: "{{date}}以降にご利用ください",
  wanna_use_coupon: "クーポンを使用しますか？",
  remaining_date: "残り時間 {{date}}",
  current_time: "現在時刻",
  valid_until: "有効期限",
  please_select: "選択してください",
  earn_a_coupon: "クーポンを獲得",
  we_re_currently_looking_for_participants_for_a_survey_via_phone_in_hopes_to_improve_our_service: "サービス向上のために、お電話でのアンケートに、ご協力いただける方を募集しています。",
  we_will_use_your_feedback_to_continue_making_our_service_better: "お客様の「声」を大切にし、より良いサービスをご提供できるよう努めてまいります。",
  thank_you_for_responding: "ご回答ありがとうございました。",
  you_can_get_a_coupon_by_responding_to_our_quiz_or_survey: "クイズとアンケートに答えるとクーポンをGetできます！",
  what_is_the_most_popular_menu_item_at_our_store: "当店の一番人気メニューは何でしょう？",
  what_is_the_new_seasonal_menu_for_next_month: "来月の季節の新メニューは何でしょう？",
  answer_text: {
    omelette_rice: "オムライス",
    pork_cutlet: "とんかつ",
    napolitan: "ナポリタン",
    tomato_hamburg: "トマトハンバーグ",
    cold_tan_tan_noodles: "冷やし担々麺",
    hitsumabushi_eel_rice: "ひつまぶし"
  },
  please_select_the_applicable_branches_for_the_survey: "アンケート対象の店舗を選択してください",
  no_matching_stores_found: "一致する店舗がありません",
  applicable_branches: "対象店舗",
  prefecture:{
    no_city_found: '一致する都道府県が見つかりませんでした',
    province_select: "都道府県",
    all_provinces_option: 'すべての都道府県',
  },
  can_search_using_keywords_like_the_branch_name: "※店舗名の一部などキーワードでの検索も可能です",
};
export default ja;
